// 静态页面路由
export default [
  {
    path: '/pd-card-calibration',
    name: 'pdCardCalibrationTest',
    component: () =>
      import('@/views/static/pd-card-calibration/PdCardCalibrationTest.vue').then(
        (r) => r.default || r,
      ),
    meta: {
      cnName: 'PD Card Calibration SDK测试页',
    },
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import('@/views/static/company/vooglam-blog.vue').then((r) => r.default || r),
    meta: {
      cnName: '博客页',
    },
  },
  {
    path: '/blogDetail/:id',
    name: 'blogDetail',
    component: () => import('@/views/static/company/blog-detail.vue').then((r) => r.default || r),
    meta: {
      cnName: '博客文章详情页',
    },
  },
  {
    path: '/blog/category/:id',
    name: 'blogTag',
    component: () => import('@/views/static/company/blog-tag.vue').then((r) => r.default || r),
    meta: {
      cnName: '博客标签列表页',
    },
  },
  {
    path: '/blog/author/:id',
    name: 'blogAuthor',
    component: () => import('@/views/static/company/blog-author.vue').then((r) => r.default || r),
    meta: {
      cnName: '博客作者文章列表页',
    },
  },
  {
    path: '/blog/result',
    name: 'VooglamBlogResult',
    component: () =>
      import('@/views/static/company/VooglamBlogResult.vue').then((r) => r.default || r),
    meta: {
      cnName: '博客搜索结果页',
    },
  },
  {
    path: '/ytb',
    name: 'ytb',
    meta: {
      pos: 0,
      cnName: 'ytb短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/ins',
    name: 'ins',
    meta: {
      pos: 0,
      cnName: 'ins短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/FBb',
    name: 'FBb',
    meta: {
      pos: 0,
      cnName: 'FBb短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/tiktok',
    name: 'tiktok',
    meta: {
      pos: 0,
      cnName: 'tiktok短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/inslist',
    name: 'inslist',
    meta: {
      pos: 0,
      cnName: 'inslist短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/fblist',
    name: 'fblist',
    meta: {
      pos: 0,
      cnName: 'fblist短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/fblink',
    name: 'fblink',
    meta: {
      pos: 0,
      cnName: 'fblink短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/page',
    name: 'page',
    meta: {
      pos: 0,
      cnName: 'page短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/group',
    name: 'group',
    meta: {
      pos: 0,
      cnName: 'group短链跳转页',
    },
    component: () =>
      import('@/views/static/social-link/social-link.vue').then((r) => r.default || r),
  },
  {
    path: '/media',
    name: 'media',
    meta: {
      pos: 0,
      cnName: 'media短链跳转页',
    },
    component: () =>
      import('@/views/static/short-link/media/index.vue').then((r) => r.default || r),
  },
  {
    path: '/taboola',
    name: 'taboola',
    meta: {
      pos: 0,
      cnName: '在线购买处方眼镜的七个理由页',
    },
    component: () => import('@/views/static/taboola/taboola.vue').then((r) => r.default || r),
  },
  {
    path: '/taboola-2',
    name: 'taboolaEurope',
    meta: {
      pos: 0,
      cnName: '在线购买处方眼镜的七个理由（欧盟）页',
    },
    component: () => import('@/views/static/taboola/taboola-2.vue').then((r) => r.default || r),
  },
  {
    path: '/sms',
    name: 'sms',
    meta: {
      pos: 0,
      cnName: 'sms短链跳转页',
    },
    component: () => import('@/views/static/short-link/sms/index.vue').then((r) => r.default || r),
  },
  {
    path: '/goods',
    name: 'goods',
    meta: {
      pos: 0,
      cnName: 'goods短链跳转页',
    },
    component: () =>
      import('@/views/static/short-link/goods/index.vue').then((r) => r.default || r),
  },
  {
    path: '/detail',
    name: 'detail',
    meta: {
      pos: 0,
      cnName: 'detail短链跳转页',
    },
    component: () =>
      import('@/views/static/short-link/detail/index.vue').then((r) => r.default || r),
  },
  {
    path: '/product',
    name: 'product',
    meta: {
      pos: 0,
      cnName: 'product短链跳转页',
    },
    component: () =>
      import('@/views/static/short-link/product/index.vue').then((r) => r.default || r),
  },
  {
    path: '/order',
    name: 'order',
    meta: {
      pos: 0,
      cnName: 'order短链跳转页',
    },
    component: () =>
      import('@/views/static/short-link/order/index.vue').then((r) => r.default || r),
  },
  {
    path: '/link',
    name: 'link',
    meta: {
      pos: 0,
      cnName: 'link短链跳转页',
    },
    component: () => import('@/views/static/short-link/link/index.vue').then((r) => r.default || r),
  },
  {
    path: '/about-us',
    name: 'aboutUs',
    meta: {
      pos: 0,
      cnName: '关于我们页',
    },
    component: () => import('@/views/static/company/about-us.vue').then((r) => r.default || r),
  },
  {
    path: '/prescription-verification',
    name: 'prescriptionVerification',
    meta: {
      pos: 0,
      cnName: '处方验证说明页',
    },
    component: () =>
      import('@/views/static/company/prescription-verification.vue').then((r) => r.default || r),
  },
  {
    path: '/contactUs',
    name: 'contactUs',
    meta: {
      pos: 0,
      cnName: '联系我们页',
    },
    component: () => import('@/views/static/company/contact-us.vue').then((r) => r.default || r),
  },
  {
    path: '/privacySecurity',
    name: 'privacySecurity',
    meta: {
      pos: 0,
      cnName: '隐私协议页',
    },
    component: () =>
      import('@/views/static/company/privacy-security.vue').then((r) => r.default || r),
  },
  {
    path: '/returnRefund',
    name: 'returnRefund',
    meta: {
      pos: 0,
      cnName: '退货退款政策页',
    },
    component: () => import('@/views/static/company/return-refund.vue').then((r) => r.default || r),
  },
  {
    path: '/klarna',
    name: 'klarna',
    meta: {
      pos: 0,
      cnName: 'klarna页',
    },
    component: () => import('@/views/static/company/klarna.vue').then((r) => r.default || r),
  },
  {
    path: '/shippingTracking',
    name: 'shippingTracking',
    meta: {
      pos: 0,
      cnName: '物流政策页',
    },
    component: () =>
      import('@/views/static/company/shipping-tracking.vue').then((r) => r.default || r),
  },
  {
    path: '/termsConditions',
    name: 'termsConditions',
    meta: {
      pos: 0,
      cnName: '服务条款页',
    },
    component: () =>
      import('@/views/static/company/terms-conditions.vue').then((r) => r.default || r),
  },
  {
    path: '/wholesale',
    name: 'wholesale',
    meta: {
      pos: 0,
      cnName: '批发页',
    },
    component: () => import('@/views/static/program/wholesale.vue').then((r) => r.default || r),
  },
  {
    path: '/influencer',
    name: 'influencer',
    meta: {
      pos: 0,
      cnName: '网红合作页',
    },
    component: () => import('@/views/static/program/influencer.vue').then((r) => r.default || r),
  },
  {
    path: '/influencerSubmit/:id',
    name: 'influencerSubmit',
    meta: {
      pos: 0,
      cnName: '网红合作申请页',
    },
    component: () =>
      import('@/views/static/program/influencer-submit.vue').then((r) => r.default || r),
  },
  {
    path: '/influencerCallback',
    name: 'influencerCallback',
    meta: {
      pos: 0,
      cnName: '网红合作申请提交成功页',
    },
    component: () =>
      import('@/views/static/program/influencer-callback.vue').then((r) => r.default || r),
  },
  {
    path: '/affiliateProgram',
    name: 'affiliateProgram',
    meta: {
      pos: 0,
      cnName: '联盟计划页',
    },
    component: () =>
      import('@/views/static/program/affiliate-program.vue').then((r) => r.default || r),
  },
  {
    path: '/kol-program',
    name: 'kolProgram',
    meta: {
      pos: 0,
      cnName: 'KOL计划页',
    },
    component: () => import('@/views/static/program/kol-program.vue').then((r) => r.default || r),
  },
  {
    path: '/affiliateProgram/earn-with-us',
    name: 'kocProgram',
    meta: {
      pos: 0,
      cnName: 'KOC计划页',
    },
    component: () => import('@/views/static/program/koc-program.vue').then((r) => r.default || r),
  },
  {
    path: '/koc_kol-program',
    name: 'kocKolProgram',
    meta: {
      pos: 0,
      cnName: 'KOC和KOL计划页',
    },
    component: () =>
      import('@/views/static/program/koc_kol-program.vue').then((r) => r.default || r),
  },
  {
    path: '/shippingnotice',
    name: 'shippingnotice',
    meta: {
      pos: 0,
      cnName: '物流提示页',
    },
    component: () =>
      import('@/views/static/company/shipping-notice.vue').then((r) => r.default || r),
  },
  {
    path: '/howToFillOutThePrescription',
    name: 'howToFillOutThePrescription',
    meta: {
      pos: 0,
      cnName: '如何填写处方页',
    },
    component: () => import('@/views/static/guide-tips/fill-out.vue').then((r) => r.default || r),
  },
  {
    path: '/guideTips',
    name: 'guideTips',
    meta: {
      cnName: '帮助提示页',
    },
    component: () => import('@/views/static/guide-tips/guide-tips.vue').then((r) => r.default || r),
    children: [
      {
        path: 'cleanGlasses',
        name: 'cleanGlasses',
        meta: {
          pos: 0,
          cnName: '帮助提示-如何清洁眼镜页',
        },
        component: () =>
          import('@/views/static/guide-tips/clean-glasses.vue').then((r) => r.default || r),
      },
      {
        path: 'wearGlasses',
        name: 'wearGlasses',
        meta: {
          pos: 0,
          cnName: '帮助提示-如何佩戴眼镜页面',
        },
        component: () =>
          import('@/views/static/guide-tips/wear-glasses.vue').then((r) => r.default || r),
      },
      {
        path: 'orderGlasses',
        name: 'orderGlasses',
        meta: {
          pos: 0,
          cnName: '帮助提示-如何在线订购眼镜页',
        },
        component: () =>
          import('@/views/static/guide-tips/order-glasses.vue').then((r) => r.default || r),
      },
      {
        path: 'antiBlue',
        name: 'antiBlue',
        meta: {
          pos: 0,
          cnName: '帮助提示-防蓝光镜片页',
        },
        component: () =>
          import('@/views/static/guide-tips/anti-blue.vue').then((r) => r.default || r),
      },
      {
        path: 'bestFrames',
        name: 'bestFrames',
        meta: {
          pos: 0,
          cnName: '帮助提示-最适合您脸型的眼镜页',
        },
        component: () =>
          import('@/views/static/guide-tips/best-frames.vue').then((r) => r.default || r),
      },
      {
        path: 'bifocalLens',
        name: 'bifocalLens',
        meta: {
          pos: 0,
          cnName: '帮助提示-双焦点镜片和渐进镜片页面',
        },
        component: () =>
          import('@/views/static/guide-tips/bifocal-lens.vue').then((r) => r.default || r),
      },
      {
        path: 'FAQs',
        name: 'FAQs',
        meta: {
          pos: 0,
          cnName: '帮助提示-更多常见问题解答页',
        },
        component: () => import('@/views/static/guide-tips/FAQs.vue').then((r) => r.default || r),
      },
      {
        path: 'features',
        name: 'features',
        meta: {
          pos: 0,
          cnName: '帮助提示-遮光镜片的特点页',
        },
        component: () =>
          import('@/views/static/guide-tips/features.vue').then((r) => r.default || r),
      },
      {
        path: 'measurePD',
        name: 'measurePD',
        meta: {
          pos: 0,
          cnName: '帮助提示-如何测量瞳距页',
        },
        component: () =>
          import('@/views/static/guide-tips/measure-PD.vue').then((r) => r.default || r),
      },
      // seo优化师建议连字符，不用小驼峰
      {
        path: 'how-to-read-glasses-prescription',
        name: 'howToReadGlassesPrescription',
        meta: {
          pos: 0,
          cnName: '帮助提示-如何阅读处方',
        },
        component: () =>
          import('@/views/static/guide-tips/how-to-read-glasses-prescription.vue').then(
            (r) => r.default || r,
          ),
      },
      {
        path: 'lensesCoating',
        name: 'lensesCoating',
        meta: {
          pos: 0,
          cnName: '帮助提示-镜片及镀膜页',
        },
        component: () =>
          import('@/views/static/guide-tips/lenses-coating.vue').then((r) => r.default || r),
      },
    ],
  },
  {
    path: '/student-discount',
    name: 'studentDiscount',
    meta: {
      pos: 0,
      cnName: '学生豆页',
    },
    component: () =>
      import('@/views/static/studentbeans/StudentDiscount.vue').then((r) => r.default || r),
  },
  // {
  //     path: '/email-coupon',
  //     name: 'edmCoupon',
  //     meta: {
  //         pos: 0,
  //     },
  //     component: () => import('@/views/edm-coupon/index.vue').then(r => r.default || r),
  // },
  {
    // 退订邮件
    path: '/unsubscribe',
    name: 'unsubscribe',
    meta: {
      pos: 0,
      cnName: '邮件退订页',
    },
    component: () => import('@/views/static/unsubscribe/index.vue').then((r) => r.default || r),
  },
  {
    // 删除账号页面
    path: '/delete-account',
    name: 'deleteAccount',
    meta: {
      pos: 0,
      cnName: '注销账号页',
    },
    component: () => import('@/views/static/delete-account/index.vue').then((r) => r.default || r),
  },
  {
    path: '/app-link',
    name: 'appLink',
    meta: {
      pos: 0,
      cnName: 'APP引流中间页',
    },
    component: () => import('@/views/static/app-link/app-link.vue').then((r) => r.default || r),
  },
  {
    path: '/fitguide',
    name: 'FitGuide',
    meta: {
      pos: 0,
      keepalive: true,
      cnName: '选镜指南页',
    },
    component: () => import('@/views/static/guide-tips/fit-guide.vue').then((r) => r.default || r),
  },
  {
    path: '/directory',
    name: 'Directory',
    meta: {
      pos: 0,
      cnName: '网站地图目录页',
      keepalive: true,
    },
    component: () => import('@/views/static/directory/index.vue').then((r) => r.default || r),
  },
  {
    path: '/write-for-us',
    name: 'writeForUs',
    meta: {
      pos: 0,
      cnName: '兼职写手页',
    },
    component: () =>
      import('@/views/static/write-for-us/write-for-us.vue').then((r) => r.default || r),
  },
  {
    path: '/survey-delete',
    name: 'SurveyDelete',
    meta: {
      pos: 0,
      cnName: '账号注销调研页',
    },
    component: () =>
      import('@/components/public/question-detail/question-detail-page.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/survey-delivery',
    name: 'SurveyDelivery',
    meta: {
      pos: 0,
      cnName: '订单签收调研页',
    },
    component: () =>
      import('@/components/public/question-detail/question-detail-page.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/survey-orderclosed',
    name: 'SurveyOrderClosed',
    meta: {
      pos: 0,
      cnName: '订单关闭48小时调研页',
    },
    component: () =>
      import('@/components/public/question-detail/question-detail-page.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/subscribe-success',
    name: 'subscribeSuccess',
    meta: {
      pos: 0,
      cnName: '订阅成功页',
    },
    component: () =>
      import('@/views/static/subscribe-success/index.vue').then((r) => r.default || r),
  },
  {
    path: '/sms-subscribe',
    name: 'smsSubscribe',
    meta: {
      pos: 0,
      cnName: '手机号订阅页',
    },
    component: () =>
      import('@/views/static/sms-subscribe/SmsSubscribe.vue').then((r) => r.default || r),
  },
];
